exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_wks-ext.js
// module id = 615
// module chunks = 0